/** @jsx h */
import { h, Fragment } from "preact";
import { useContext } from "preact/hooks";
import { renderPreact } from "../lib/render-preact";
import PageContext from "./PageContext";
import { translate, t } from "restaumatic-client/src/I18n";
function PoweredBy(props) {
    var _a;
    const settings = useContext(PageContext);
    return (h(Fragment, null,
        h("span", null, translate(t.theme_defaults.theme.powered_by)),
        h("a", { href: "//www.restaumatic.com/" + settings.locale, class: (_a = props.poweredByLinkClass) !== null && _a !== void 0 ? _a : "u-link-wrapper", target: "_parent", "data-ga-action": "Clicks on the Restaumatic link in the footer", rel: "nofollow" },
            "\u00A0",
            h("svg", { width: "130", height: "26", class: "svg-icon-restaumatic u-va-middle", role: "img", "aria-label": translate(t.generic.restaumatic) },
                h("use", { href: "#svg-icon-restaumatic" })))));
}
export default renderPreact("PoweredBy", PoweredBy);
